import styled from '@emotion/styled';
import {sizes} from 'patient-ping-remedy/packages/theme';

export const ReferralFaxRow = styled.div`
  margin-top: ${sizes.xSmall};
`;

export const ReferralFaxDetails = styled.div`
  padding-left: 2.5rem;
`;
